import React from 'react';
import { createStore, createStyleSet } from 'botframework-webchat';
import { reduceMini } from './reducers/MinimizableWebChatReduce';

import WebChat from './WebChat';

import './fabric-icons-inline.css';
import './MinimizableWebChat.css';
import AvatarCliente from './images/avatar-cliente.png';
import AvatarFebraban from './images/avatar-febraban.png';


export default class extends React.Component {
    constructor(props) {
        super(props);

        this.handleFetchToken = this.handleFetchToken.bind(this);
        this.handleMaximizeButtonClick = this.handleMaximizeButtonClick.bind(this);
        this.handleMinimizeButtonClick = this.handleMinimizeButtonClick.bind(this);

        const store = createStore({}, reduceMini);


        this.state = {
            minimized: false,
            side: 'right',
            store,
            styleSet: createStyleSet({
                hideUploadButton: true,
                backgroundColor: 'White',
                bubbleBackground: 'rgba(237, 240, 245)',
                bubbleFromUserBackground: 'rgba(64, 143, 236)',
                botAvatarInitials: 'FE',
                botAvatarImage: AvatarFebraban,
                userAvatarImage: AvatarCliente,
                userAvatarInitials: 'CL'
            }),
            token: null
        };
    }

    async handleFetchToken() {
        if (!this.state.token) {
            this.setState(() => ({ token: 'cxxHAy0EPHY.Onc2U6aOfcmLFnFSLUFNet9ErdOop5oajPbomFERV6E' }));
        }
    }

    handleMaximizeButtonClick() {
        this.setState(() => ({
            minimized: false
        }));
    }

    handleMinimizeButtonClick() {
        this.state.store.dispatch({
            type: 'WEB_CHAT/SEND_EVENT',
            payload: {
                name: 'webchat/end',
                value: {
                    language: 'pt-br'
                },
                activities: {}
            }
        });
        this.setState(() => ({
            minimized: true
        }));
    }

    render() {
        const { state: {
            minimized,
            side,
            store,
            styleSet,
            token
        } } = this;

        return (
            <div className="minimizable-web-chat">
                {
                    minimized ?
                        <button
                            className="maximize"
                            onClick={this.handleMaximizeButtonClick}
                        >
                            <span className={token ? 'ms-Icon ms-Icon--MessageFill' : 'ms-Icon ms-Icon--Message'} />
                        </button>
                        :
                        <div
                            className={side === 'left' ? 'chat-box left' : 'chat-box right'}
                        >
                            <header>
                                <span className="title"> Assistente Virtual FEBRABAN</span>
                                <div className="filler" />
                                <button
                                    className="minimize"
                                    onClick={this.handleMinimizeButtonClick}
                                >
                                    <span className="ms-Icon ms-Icon--ChromeMinimize" />
                                </button>
                            </header>
                            <div className='middleBack'>
                                <WebChat
                                    className="react-web-chat"
                                    onFetchToken={this.handleFetchToken}
                                    store={store}
                                    styleSet={styleSet}
                                    token={token}
                                />
                            </div>
                        </div>
                }
            </div>
        );
    }
}